import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  html,
  body {
    height: 100%;
    width: 100%;
    background: #180d23;
    color: rgba(245, 225, 255, 0.74);
  }

  body {
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }

  #root {
    min-height: 100%;
    min-width: 100%;
    z-index: 1;

  }


  p,
  label {
    font-family: 'Raleway', sans-serif;
    line-height: 1.5em;
    font-size: 24px;

    @media only screen and (max-width: 600px) {
      font-size: 16px;
    }
  }

  p.caption {
    font-family: 'Jura', sans-serif;
    font-size: 20px;
  }

  p.error {
    font-family: 'Jura', sans-serif;
    font-size: 20px;
    color: #FD6C6E;
    margin-bottom: 0px;
  }

  input, select {
    font-family: inherit;
    font-size: inherit;
  }

  h1 {
    font-family: 'Jura';
    font-style: normal;
    font-weight: 400;
    font-size: 32px;
    line-height: 52px;
    text-align: center;

    color: rgba(245, 225, 255, 0.74);

    @media only screen and (max-width: 600px) {
      font-size: 24px;
    }
  }

  h2 {
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 700;
    font-size: 32px;
    line-height: 38px;
    text-align: center;

    color: #FFF;
    margin-top: 10px;
    margin-bottom: 10px;

    @media only screen and (max-width: 600px) {
      line-height: 30px;
      font-size: 22px;
    }
  }

  h3 {
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 300;
    font-size: 24px;
    line-height: 28px;
    text-align: center;

    color: rgba(245, 225, 255, 0.74);
    margin-top: 0px;
    margin-bottom: 20px;

    @media only screen and (max-width: 600px) {
      font-size: 18px;
      line-height: 20px;
    }
  }
  
  h5 {
    /* typography/h5 */
    color: #FFFFFF;
    font-family: Raleway;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 133.4%; /* 32.016px */
    
    margin: 0;
  }

  .color-pink {
    color: #FF74E9;
  }

  a.color-pink:hover {
    text-decoration: underline;
  }

  /* LANDING PAGE PRIMARY BUTTON */
  button.landing-primary-button {
    cursor: pointer;
    height: 60px;
    padding-left: 40px;
    padding-right: 40px;
    margin: 20px;
    text-transform: uppercase;

    /* buttonGradient */
    //background: linear-gradient(102deg, #FFF 17.69%, rgba(245, 225, 255, 0.74) 95.16%);
    border-radius: 30px;
    border: none;

    font-family: 'Jura';
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 33px;
    text-align: center;

    color: #180d23;

    transition: color, background 0.5s ease;

    position: relative;
    z-index: 1; /* matters! */
    overflow: hidden;

    &.small {
      height: 60px;
      padding-left: 20px;
      padding-right: 20px;
      margin: 20px;
      font-size: 20px;
      line-height: 24px;
    }

    @media only screen and (max-width: 600px) {
      font-size: 20px;
      height: 60px;
      padding-left: 20px;
      padding-right: 20px;
      margin: 20px auto;
      font-size: 20px;
      line-height: 24px;
    }

  }

  // animated background gradient
  button.landing-primary-button::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 210%;
    height: 100%;
    background: linear-gradient(102deg, #FFF 17.69%, rgba(245, 225, 255, 0.74) 46%, #7D0EB599 54%, #7D0EB5 100%);
    transition: transform 0.4s;
    z-index: -1
  }

  button.landing-primary-button:hover {
    //background: linear-gradient(102deg, #7D0EB5 17.69%, #7D0EB5 95.16%);
    color: rgba(245, 225, 255, 1);
    transition: color 0.5s ease;
  }

  button.landing-primary-button:hover::before {
    transform: translateX(-51%);

  }

  /* PRIMARY BUTTON */
  button.primary-button {
    cursor: pointer;
    height: 80px;
    padding-left: 40px;
    padding-right: 40px;
    margin: 20px;
    text-transform: uppercase;

    /* buttonGradient */
    background: linear-gradient(180deg, #7D0EB5 0%, #4D0671 100%);
    border-radius: 15px;
    border: none;

    font-family: 'Jura';
    font-style: normal;
    font-weight: 700;
    font-size: 28px;
    line-height: 33px;
    text-align: center;

    color: rgba(245, 225, 255, 0.74);

    &.small {
      height: 60px;
      padding-left: 20px;
      padding-right: 20px;
      margin: 20px;
      font-size: 20px;
      line-height: 24px;
    }

    &.x-small {
      height: 40px;
      padding-left: 20px;
      padding-right: 20px;
      margin: 10px;
      font-size: 16px;
      line-height: 20px;
    }

    @media only screen and (max-width: 600px) {
      font-size: 20px;
    }

  }

  button.primary-button:hover {
    background: #7D0EB5;
    color: rgba(245, 225, 255, 1);
    transition: color 0.5s ease;
  }

  button:disabled,
  button[disabled] {
    opacity: 0.6;
  }

  /* SECONDARY BUTTON */
  button.secondary-button {
    cursor: pointer;
    height: 80px;
    padding-left: 40px;
    padding-right: 40px;
    margin: 20px;
    text-transform: uppercase;

    /* buttonGradient */
    background: none;
    border-radius: 15px;
    border: 1px solid rgba(245, 225, 255, 0.74);

    font-family: 'Jura';
    font-style: normal;
    font-weight: 700;
    font-size: 28px;
    line-height: 33px;
    text-align: center;

    color: rgba(245, 225, 255, 0.74);

    &.small {
      height: 60px;
      padding-left: 20px;
      padding-right: 20px;
      margin: 20px;
      font-size: 20px;
      line-height: 24px;
    }

  }

  button.secondary-button:hover {
    background: none;
    color: rgba(245, 225, 255, 1);
    transition: color 0.5s ease;
  }


  button.inline-button {
    cursor: pointer;
    height: 50px;
    padding-left: 20px;
    padding-right: 20px;
    margin-left: 10px;
    margin-right: 10px;
    text-transform: uppercase;

    /* button background*/
    background: #FF74E9;
    border-radius: 15px;
    border: none;

    font-family: 'Jura';
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 33px;
    text-align: center;

    color: #111618;

  }

  button.inline-button:hover {
    background: #7D0EB5;
    color: rgba(245, 225, 255, 1);
    transition: color 0.5s ease;
  }

  button.input-button {
    cursor: pointer;
    height: 50px;
    padding-left: 20px;
    padding-right: 20px;
    margin-left: 10px;
    margin-right: 10px;
    text-transform: uppercase;

    /* button background*/
    background: none;
    border-radius: 15px;
    border: none;

    font-family: 'Jura';
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 33px;
    text-align: center;

    color: rgba(245, 225, 255, 0.74);

  }

  button.input-button:hover {
    background: #7D0EB5;
    color: rgba(245, 225, 255, 1);
    transition: color 0.5s ease;
  }

  button.record-button {
    cursor: pointer;
    height: 50px;
    padding-left: 20px;
    padding-right: 20px;
    margin-left: 10px;
    margin-right: 10px;
    text-transform: uppercase;

    width: 200px;
    height: 56px;

    /* button background*/
    background: #B200A1;
    border-radius: 10px;
    border: none;

    font-family: 'Jura';
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 33px;
    text-align: center;

    color: #FFF;

    @media only screen and (max-width: 600px) {
      width: 100%;
      font-size: 20px;
    }

  }

  button.record-button:hover {
    background: #de2fc3;
    color: rgba(255, 225, 255, 1);
    transition: color 0.5s ease;
  }

  .triple-dot-button {
    font-size: 18px;
  }

  /* SCROLLBAR */
  ///* width */
  //::-webkit-scrollbar {
  //  width: 10px;
  //}
  //
  ///* Track */
  //::-webkit-scrollbar-track {
  //  background: rgba(125, 14, 181, 0.5);
  //}
  //
  ///* Handle */
  //::-webkit-scrollbar-thumb {
  //  background: rgba(245, 225, 255, 0.74);
  //}
  //
  ///* Handle on hover */
  //::-webkit-scrollbar-thumb:hover {
  //  background: #FF74E9;
  //}


  /* TEXT INPUT + EASY EDIT */
  input {
    background: #180D23;
    border: 1px solid rgba(245, 225, 255, 0.74);
    border-radius: 15px;
    color: rgba(245, 225, 255, 0.74);
    padding: 5px 10px;
  }

  input.small {
    background: #180D23;
    border: 1px solid rgba(245, 225, 255, 0.74);
    border-radius: 15px;
    color: rgba(245, 225, 255, 0.74);
    padding: 5px 5px;
    font-size: 20px;
    text-align: center;
  }

  input:hover {
    border: 1px solid #FF74E9;
    outline: none;
  }

  input:focus {
    border: 1px solid #FF74E9;
    outline: none;
  }

  // Remove hover and focus effect for material ui 
  .MuiInputBase-root {
    input:hover {
      border: none;
    }

    input:focus {
      border: none;
    }
  }

  .easy-edit-inline-wrapper {
    display: flex;
    flex-direction: row;
    align-content: center;
  }

  button.easy-edit-button {
    cursor: pointer;
    padding: 0px;
    background: none;
    color: rgba(245, 225, 255, 0.74);

    p {
      margin: 0px;
      font-size: 18px;
    }
  }

  .separator-label {
    margin-top: 30px;
    margin-bottom: 20px;
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 23px;
    text-align: center;
    color: #FDE9FF;
  }

  .prevent-select {
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */
  }

  /* CLERK SIGN IN AUTH MODAL STYLES */
  .cl-card {
    border-radius: 20px;
    border: 1px solid rgba(255, 116, 233, 0.74);
    background: #180728;
  }
  .cl-headerTitle {
    color: var(--text-primary, #FFF);
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Raleway;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 100%; /* 24px */

    margin-bottom: 10px;
  }
  .cl-headerSubtitle {
    color: var(--text-disabled, rgba(245, 225, 255, 0.74));
    text-align: center;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Raleway;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 133.4%; /* 21.344px */
  }
  .cl-socialButtonsBlockButton {
    background-color: #FFF;
    border: 1px solid #7d0eb5;
    color: #000 !important;

    &:hover {
      background-color: #FDE9FF;
    }
  }
  .cl-dividerLine {
    background-color: var(--text-disabled, rgba(245, 225, 255, 0.74));
  }
  .cl-dividerText {
    color: var(--text-disabled, rgba(245, 225, 255, 0.74));
  }
  .cl-modalCloseButton {
    color: #FF74E9;
  }
  .cl-modalCloseButton:hover {
    background-color: #FF74E9;
    color: #180D23;
  }
  .cl-formFieldLabel {
    color: #FDE9FF;
  }
  .cl-formFieldInput {
    color: #FDE9FF;
    background-color: #180D23;
    border: 1px solid var(--text-disabled, rgba(245, 225, 255, 0.74));
    outline: none;
    box-shadow: none;
    accent-color: #FF74E9;
  }
  .cl-formFieldInput:hover {
    border: 1px solid #FF74E9;
    outline: none;
  }
  .cl-formFieldInput:focus {
    border: 1px solid #FF74E9;
    outline: none;
  }
  .cl-footerActionText {
    color: #FDE9FF;
  }
  .cl-footerActionLink {
    color: #FF74E9;
  }
  .cl-formButtonPrimary {
    border-radius: 15px;
    background: linear-gradient(180deg, #7D0EB5 0%, #4D0671 100%);

    color: rgba(245, 225, 255, 0.74);
    text-align: center;
    font-family: 'Raleway';
    font-size: 18px;
    font-style: normal;
    font-weight: 300;
    line-height: 33px; /* 117.857% */

    &:hover {
      color: rgba(245, 225, 255, 1);
      transition: color 0.5s ease;
      background: linear-gradient(180deg, #7D0EB5 0%, #7D0EB5 100%);
    }
  }
  .cl-formFieldErrorText {
    color: #FD6C6E;

    svg {
      color: #FD6C6E;
    }
  }
  .cl-formFieldSuccessText {
    color: var(--text-disabled, rgba(245, 225, 255, 0.74));

    svg {
      color: var(--text-disabled, rgba(245, 225, 255, 0.74));
    }
  }
  .cl-navbarButton {
    color: rgba(245, 225, 255, 0.74);

    svg {
      color: rgba(245, 225, 255, 0.74);
    }
  }
  .cl-profileSectionTitleText {
    color: var(--text-primary, #FFF);
    font-feature-settings: 'liga' off, 'clig' off;

    /* menu/itemDefault */
    font-family: Jura;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%; /* 24px */
    letter-spacing: 0.15px;
  }
  .cl-userPreview {
    color: var(--text-primary, #FDE9FF);
    font-family: Raleway;
    font-size: 13px;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
    letter-spacing: -0.26px;

    svg {
      color: var(--text-primary, #FDE9FF);
    }
  }
  .cl-profileSectionPrimaryButton {
    border: 1px solid var(--text-disabled, rgba(245, 225, 255, 0.74));

    --accent: rgba(255, 116, 233, 0.74);
    
    &:hover {
      background: #FF74E911;
      border: 1px solid #FF74E9;

      svg {
        color: #FF74E9;
      }
    }
  }
  .cl-breadcrumbsItem, .cl-breadcrumbsItemDivider {
    color: #FDE9FF;
  }
  .cl-breadcrumbsItemBox {
    -webkit-box-align: center;
    align-items: center;
  }
  .cl-formButtonReset {
    color: rgba(245, 225, 255, 0.74);
    border-radius: 15px;
  }
  .cl-formButtonReset:hover {
    color: rgba(245, 225, 255, 1);
    background-color: rgba(245, 225, 255, 0.2);
  }

  .cl-pageScrollBox {
    p, span {
      color: rgba(245, 225, 255, 0.74) !important;
    }

    button {
      color: rgba(245, 225, 255, 0.74);
      border-radius: 15px !important;

      &:hover {
        color: rgba(245, 225, 255, 1) !important;
        background-color: rgba(245, 225, 255, 0.2) !important;
      }
    }

    [data-localization-key="userProfile.start.emailAddressesSection.destructiveAction"] {
      color: #FD6C6E !important;
      
      &:hover {
        background-color: rgba(253, 108, 110, 0.2) !important;
        color: #FD6C6E !important;
      }
    }
  }

  .cl-navbar {
    background-color: #180D23;
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
  }

  .cl-identityPreviewText, .cl-formHeaderTitle, .cl-formHeaderSubtitle, .cl-otpCodeFieldInputs {
    color: #FDE9FF;
  }

  .cl-otpCodeFieldInput {
    color: #FDE9FF;
    border-bottom: 1px solid #FDE9FF;
    accent-color: rgba(255, 116, 233, 0.74);

    &:focus {
      border-color: rgba(255, 116, 233, 0.74);
    }
  }

  .cl-formResendCodeLink, .cl-identityPreviewEditButton {
    color: rgba(255, 116, 233, 0.74);
  }

  .cl-alert {
    border: 1px solid #FDE9FF22;
    color: #FDE9FF;
  }
  .cl-alertText__danger {
    color: #FD6C6E;
  }
  
  /* AI ADDED? */
  /* AI ADDED? */
  .cl-modal {
    background-color: #180D23;
  }
  .cl-modalContent {
    background-color: #180D23;

  }

  .cl-footerPagesLink {
    color: #FDE9FF;
  }

  .tree-view-output {
    font-size: 14px;
  }
`;
